import * as actions from "@/AppRedux/actions/admin/hotelList/hotelListType";

export const getHotelList = (): actions.GetHotelListRequest => ({
    type: actions.GET_HOTEL_LIST_REQUEST
});

export const getHotelListSuccess = (payload: actions.HotelListItem[]): actions.GetHotelListSuccess => ({
    type: actions.GET_HOTEL_LIST_SUCCESS,
    payload
});

export const getHotelListFailed = (error: string): actions.GetHotelListFailed => ({
    type: actions.GET_HOTEL_LIST_FAILED,
    payload: error
});

export const getHotelProfileRequest = (id: string): actions.GetHotelProfileRequest => ({
    type: actions.GET_HOTEL_PROFILE_REQUEST,
    payload: { id }
});

export const getHotelProfileSuccess = (payload: actions.HotelProfileData): actions.GetHotelProfileSuccess => ({
    type: actions.GET_HOTEL_PROFILE_SUCCESS,
    payload
});

export const getHotelProfileFailed = (message: string): actions.GetHotelProfileFailed => ({
    type: actions.GET_HOTEL_PROFILE_FAILED,
    payload: message
});

export const createHotelProfileRequest = (payload: actions.HotelProfileCreatePayload): actions.CreateHotelProfileRequest => ({
    type: actions.CREATE_HOTEL_PROFILE_REQUEST,
    payload
});

export const createHotelProfileSuccess = (): actions.CreateHotelProfileSuccess => ({
    type: actions.CREATE_HOTEL_PROFILE_SUCCESS
});

export const createHotelProfileFailed = (message: string): actions.CreateHotelProfileFailed => ({
    type: actions.CREATE_HOTEL_PROFILE_FAILED,
    payload: message
});

export const updateHotelProfileRequest = (payload: actions.HotelProfileUpdatePayload): actions.UpdateHotelProfileRequest => ({
    type: actions.UPDATE_HOTEL_PROFILE_REQUEST,
    payload
});

export const updateHotelProfileSuccess = (): actions.UpdateHotelProfileSuccess => ({
    type: actions.UPDATE_HOTEL_PROFILE_SUCCESS
});

export const updateHotelProfileFailed = (message: string): actions.UpdateHotelProfileFailed => ({
    type: actions.UPDATE_HOTEL_PROFILE_FAILED,
    payload: message
});

export const updateHotelProfileEnabledRequest = (payload: actions.HotelProfileEnabledUpdatePayload): actions.UpdateHotelProfileEnabledRequest => ({
    type: actions.UPDATE_HOTEL_PROFILE_ENABLED_REQUEST,
    payload
});

export const updateHotelProfileEnabledSuccess = (): actions.UpdateHotelProfileEnabledSuccess => ({
    type: actions.UPDATE_HOTEL_PROFILE_ENABLED_SUCCESS
});

export const updateHotelProfileEnabledFailed = (id: string, message: string): actions.UpdateHotelProfileEnabledFailed => ({
    type: actions.UPDATE_HOTEL_PROFILE_ENABLED_FAILED,
    payload: { id, message }
});

export const getHotelListProcessClear = (): actions.GetHotelListProcessClear => ({
    type: actions.GET_HOTEL_LIST_PROCESS_CLEAR
});
